import { createModel } from '@/store/tools';

const model = {
    namespace: 'structure',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getDeptPullDown': T('getDeptPullDown'),
            'getEmpPullDown': T('getEmpPullDown'),
            'getDeptList': T('getDeptList'),
        },
        actions: {
            'getDeptPullDown': A('getDeptPullDown'),
            'getEmpPullDown': A('getEmpPullDown'),
            'getDeptList': A('getDeptList'),
        },
        sagas: {
            'getDeptPullDown': S('getDeptPullDown', '/?cmd=com.xqxc.api.pig.mis.biz.account.DeptMisService.listDeptPullDown'),
            'getEmpPullDown': S('getEmpPullDown', '/?cmd=com.xqxc.api.pig.mis.biz.account.EmplMisService.listEmpPullDown'),
            'getDeptList': S('getDeptList', '/?cmd=com.xqxc.api.pig.mis.biz.account.DeptMisService.listDeptInfo'),
        },
        reducers: {
            'getDeptPullDown': R('getDeptPullDown', []),
            'getEmpPullDown': R('getEmpPullDown', []),
            'getDeptList': R('getDeptList', []),
        }
    })
};
export default createModel(model);